$(document).ready(function() {
    $(function () {
        let hiddenImages = $('.image-container .mosaicflow__item.hide')
        hiddenImages.each((i, e) => {
            if (window.innerWidth < 800 && i === 20) {
                return false
            } else if (window.innerWidth > 800 && i === 19) {
                return false
            } else {
                e.classList.remove('hide')
                e.classList.add('visible')
            }
        })
        imageCounter()

        $('.btn-wrapper').on('click', 'button', onFilterBtnImages)
        $('.pagination').on('click', '.paginatonBtn', pseudoPagination)
        $('.pagination').on('click', '.scrollTop', scrollTop)
        $('.customer-gallery-sections').on('click', controlModalWindow)

    });

    $('.mosaicflow-gallery').mosaicflow({
        itemSelector: '.item',
        minItemWidth: 380,
        minColumns: 2
    });

});

function scrollTop() {
    $('html, body').animate({
        scrollTop: $("body").offset().top
    }, 1000);
}

function onFilterBtnImages(e) {
    const images = $('.mosaicflow__item.item')
    $('.btn-wrapper').find('button.active').removeClass('active')
    $(this).addClass('active')
    let searchEl = $(`.image-container img[data-filter-name=${$(this)[0].dataset.filterName}]`)
    if ($('.pagination button').hasClass('scrollTop')) {
        $('.pagination button').removeClass('scrollTop')
        $('.pagination button').addClass('paginationBtn')
        $('.pagination button').text('LOAD MORE')
    }
    if ($(this)[0].dataset.filterName === 'all') {
        images.removeClass('visible')
        images.addClass('hide')
        $('.pagination button').removeClass('hide')
        pseudoPagination(true)
        imageCounter($(this)[0].dataset.filterName)
        return false
    } else {
        $('.pagination button').addClass('hide')
        images.removeClass('visible')
        images.addClass('hide')
        searchEl.parent().removeClass('hide')
        searchEl.parent().addClass('visible')
        imageCounter($(this)[0].dataset.filterName)
    }
}

function pseudoPagination(firstStep) {
    if (firstStep === true) {
        $('.image-container .mosaicflow__item').find('.visible').addClass('hide').removeClass('visible');
        let hiddenImages = $('.image-container .mosaicflow__item');
        hiddenImages.each((i) => {
            if (window.innerWidth < 800 && i === 19) {
                imageCounter();
                return false;
            } else if (window.innerWidth <= 1500 && i === 20) {
                imageCounter();
                return false;
            }else if(i === 30){
                imageCounter();
                return false;
            }
            $(`#mosaic-0-itemid-${i}`).removeClass('hide').addClass('visible')
        })
        return false
    }
    let column = $('.mosaicflow__column');
    let content_item_height = $('.content-item[data-size-cell="1"]').innerHeight();
    let countElements = 10
    let max_additional_height = content_item_height * countElements;
    let columnsHeights = [];
    column.each((i, e) => {
        columnsHeights[i] = $(e).innerHeight();
    });

    var lowestColumn = Math.min.apply(null, columnsHeights);
    let max_column_height = lowestColumn + max_additional_height;
    column.each((i, e) => {
        let column_height = $(e).height();
        $(e).find('.mosaicflow__item.hide').each((i, e) => {
            let cur_item_height = content_item_height;
            if($(e).find('.media-content[data-size-cell="2"]').length > 0){

                cur_item_height *= 2;
            }
            column_height += cur_item_height;
            if(column_height <= max_column_height) {
                $(e).removeClass('hide');

                $(e).addClass('visible');
            }else{
                return false
            }
        })
    })

    if ($('.mosaicflow__item.item.hide').length < 1) {
        if (window.innerWidth < 960) {
            $('.pagination button').removeClass('paginationBtn')
            $('.pagination button').addClass('scrollTop')
            $('.pagination button').text('SCROLL TO TOP')
        } else {
            $('.pagination button').addClass('hide')
        }
    }
    $('.mosaicflow__item:not(.hide):not(.opened) iframe').attr('src', $('.mosaicflow__item iframe').attr('data-src'));
    $('.mosaicflow__item:not(.hide):not(.opened) iframe').addClass('opened');
    imageCounter()
}

function controlModalWindow(e) {
    const img = $('.modal-window img')
    const video = $('.modal-window iframe')
    onClearState()
    video.attr('src', '')
    let contentType = $(e.target).attr('data-type-content');
    const modalWindow = $('.modal-window');
    modalWindow.attr('data-content', contentType)
    if (modalWindow.attr('data-content') === 'image') {
        $('img.modal__item').addClass('active')
    } else if (modalWindow.attr('data-content') === 'video') {
        $('iframe.modal__item').addClass('active')
        $('.wrapper-video').addClass('active')
    }
    let parentTarget;
    contentType === 'video' ? parentTarget = $(e.target).parent() : parentTarget = $(e.target).parent()

    if (modalWindow.attr('data-state') !== 'open' && !parentTarget.hasClass('item-modal')) {
        return false
    }
    let nextTarget, prevTarget;

    if (parentTarget.hasClass('item-modal') && modalWindow.attr('data-state') !== 'open') {
        onOpenModal(contentType)
    } else if ($(e.target).parent().hasClass('arrow-down next') || $(e.target).parent().context === $('.arrow-down.next')[0]) {

        onNextPhoto()
    } else if ($(e.target).parent().hasClass('arrow-down prev') || $(e.target).parent().context === $('.arrow-down.prev')[0]) {
        onPrevPhoto()
    } else {
        $('body').css("overflow", "auto")
        video.attr('src', '')
        modalWindow.attr('data-state', 'clouse')
        onClearState()
        return false
    }

    function onClearState() {
        $('img.modal__item').removeClass('active')
        $('iframe.modal__item').removeClass('active')
        $('.wrapper-video').removeClass('active')
    }

    function onSetState() {
        if (modalWindow.attr('data-content') === 'image') {
            $('img.modal__item').addClass('active')
        } else if (modalWindow.attr('data-content') === 'video') {
            $('iframe.modal__item').addClass('active')
            $('.wrapper-video').addClass('active')
        }
    }

    function onOpenModal(type) {
        let contentWindow = type === 'image' ? img : video
        contentWindow.attr('src', parentTarget.find('.content-item').attr('src')).attr('data-parent-image', parentTarget.attr('id'))
        modalWindow.attr('data-state', 'open')
        $('body').css("overflow", "hidden")
    }

    function onNextPhoto() {
        let currentIdTarget = Number($('.content .modal__item.active').attr('data-parent-image').replace('mosaic-0-itemid-', ''))
        let increment = currentIdTarget + 1;
        $('.content .modal__item.active').attr('data-direction', 'stop')
        if ($('.content .modal__item.active').attr('data-parent-image') === $('.item-modal').eq(-1).attr('id')) {
            nextTarget = $('.item-modal').eq(0)
        } else {
            nextTarget = $(`#mosaic-0-itemid-${increment}`)
        }
        contentType = nextTarget.find($('[data-type-content]')).attr('data-type-content');
        modalWindow.attr('data-content', contentType)
        onClearState()
        onSetState()
        setTimeout(() => {
            $('.content .modal__item.active').attr('data-direction', 'left')
            $('.content .modal__item.active').attr('src', nextTarget.find('.content-item').attr('src')).attr('data-parent-image', nextTarget.attr('id'))
        }, 400)
    }

    function onPrevPhoto() {
        let currentIdTarget = Number($('.content .modal__item.active').attr('data-parent-image').replace('mosaic-0-itemid-', ''))
        let decrement = currentIdTarget - 1;
        $('.content .modal__item.active').attr('data-direction', 'stop')
        if (decrement === 0) {
            prevTarget = $('.item-modal').eq(-1)
        } else {
            prevTarget = $(`#mosaic-0-itemid-${decrement}`)
        }
        contentType = prevTarget.find($('[data-type-content]')).attr('data-type-content');
        modalWindow.attr('data-content', contentType)
        onClearState()
        onSetState()
        setTimeout(() => {
            $('.content .modal__item.active').attr('src', prevTarget.find('.content-item').attr('src')).attr('data-parent-image', prevTarget.attr('id'))
            $('.content .modal__item.active').attr('data-direction', 'right')
        }, 400)

    }
}

function imageCounter(target) {
    const countAllPhotos = $('.AllPhotos')
    const currentCountsPhotos = $('.currentPhoto')

    let images = null, visiblePhotos = null;
    if (!target || target === 'all'){
        visiblePhotos = $('.item-modal.visible')
        images = $('.item-modal')
        countAllPhotos.text(images.length )
    } else {
        visiblePhotos = $(`img[data-filter-name='${target}']`)
        images = visiblePhotos
        countAllPhotos.text(images.length)
    }
    currentCountsPhotos.text(visiblePhotos.length)
}


